import { reducers } from './reducers';
import { createSlice } from 'utils/@reduxjs/toolkit';
import { ServiceDataState } from './types';

export const initialState: ServiceDataState = {
  isLoading: false,
  data: null,
  error: null,
};

const slice = createSlice({
  name: 'selectServiceData',
  initialState,
  reducers,
});

export const { actions: selectServiceDataActions } = slice;
export const { reducer: selectServiceDataReducer } = slice;
